import { makeRequest } from 'utils/requestLogger';

export default (participationID, message) =>
  makeRequest('post', `/api/participations/${participationID}/nudge`, {
    message,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/nudge.js